import styled from "styled-components";

export const StyledFooter = styled.div`

  padding: 0px 25px; 
background: #F4F6FC; 
display: flex;
flex: 1;
align-items: center;
justify-content: space-evenly;
flex-direction: row;

   padding: 30px 60px;
     
        .footer__logo{
                text-align:left;
                display: flex;
                flex-direction: column;
                width: 40%;
            main{
                display: flex;
                flex-direction: column;
                div{
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 24px;
                    color: #5B5971;
                }
            }
        }

     .footer__content{
           display: grid;
           grid-template-columns : repeat(3, 1fr);
          width: 55%;

           .footer_company{
            /* align-items: center; */
            padding: 10px;
                strong{
                    
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 30px;
                    color: #1C1939;
                }
                p{
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 26px;
                    color: #5B5971;
                }
               }
               .footer_features{
            /* align-items: center; */
            padding: 10px;
                strong{
                    padding-bottom: 10px;
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 30px;
                    color: #1C1939;
                }
                p{
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 26px;
                    color: #5B5971;
                }
               }
               .footer_address{
            /* align-items: center; */
            padding: 10px;
                strong{
                    margin-bottom: 10px;
                    font-weight: 500;
                    font-size: 20px;
                    line-height: 30px;
                    
                }
                div{
                    margin-top: 12px;
                    display: flex;
                    cursor: pointer;
                    outline-width:0;
                    border: 1px solid #377DFF;
                    border-radius: 8px;
                  
                    input{
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 14px;
                        border: none;
                        outline-width: 0;
                        background-color:transparent;
                       
                        padding: 8px;
                        color: #000000;
                    }
                        span{
                            padding: 9px;
                         
                        }

                }
                div:hover {
               border: 0.125rem solid #377DFF;
        }
            }
     }
     @media (max-width:892px ) {
          min-width: 900px;
            background: #F4F6FC; 
            display: flex;
            align-items: center;
            flex-direction: column;
             padding: 30px 40px;
             .footer__logo{
                text-align: center;
                font-size: 16px;
             }
     }

`